const openCreateRepresentative = function () {
  return this.openCreaRappresentante()
}

export default {
  bindTo: 'this',
  method: openCreateRepresentative
}
